import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BarChartReport from "./BarChartReport";
import LineChartReport from "./LineChartReport";
import PieChartReport from "./PieChartReport";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import reportAction from "../../../store/actions/reportCampaignAction";
import constantsReportCampaign from "./constants/reportCampaign";
import activeChart from "../../../store/actions/activeChart";

const ChartReport = ({
  campaignTypeCategorySelected,
  whichTypeSelect,
  campaignIdSelected,
  active_chart,
  setEventDataChart,
  date_from,
  date_to,
  whichSeparationActive,
  getCampaignsDataChartWithCampaignName,
  getCampaignsDataChartWithCampaignType,
  getCampaignsDataSeparationWithCampaignName,
  getCampaignsDataSeparationWithCampaignType,
}) => {
  let chartComponent;
  switch (active_chart) {
    case activeChart.BAR:
      chartComponent = <BarChartReport />;
      break;
    case activeChart.LINE_SIMPLE:
      chartComponent = <LineChartReport />;
      break;
  }

  const [optionsTagInSelectEvent, setOptionsTagInSelectEvent] = useState([]);

  useEffect(() => {
    for (const key in eventAdvertise.eventAdvertiseString) {
      const eventAdvertiseStringItem =
        eventAdvertise.eventAdvertisePersian[key];
      setOptionsTagInSelectEvent((pervState) => [
        ...pervState,
        <option value={eventAdvertise.eventAdvertiseString[key]}>
          {eventAdvertiseStringItem}
        </option>,
      ]);
    }
  }, []);

  const selectTagEventSelectTagOnChangeHandler = (e) => {
    const eventDataChart = e.target.value;
    setEventDataChart({
      event_data_chart: eventDataChart,
    });
    switch (whichTypeSelect) {
      case constantsReportCampaign.whichTypeSelect.CAMPAIGN:
        getCampaignsDataChartWithCampaignName({
          campaign_id: campaignIdSelected,
          event_data_chart: eventDataChart,
          date_from: date_from,
          date_to: date_to,
        });
        getCampaignsDataSeparationWithCampaignName({
          campaign_id: campaignIdSelected,
          separation: whichSeparationActive,
          date_from: date_from,
          date_to: date_to,
        });
        break;
      case constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS:
        getCampaignsDataChartWithCampaignType({
          campaign_type: campaignTypeCategorySelected,
          event_data_chart: eventDataChart,
          date_from: date_from,
          date_to: date_to,
        });
        getCampaignsDataSeparationWithCampaignType({
          campaign_type: campaignTypeCategorySelected,
          separation: whichSeparationActive,
          date_from: date_from,
          date_to: date_to,
        });
        break;
    }
  };

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-4 pb-2">
      <div>
        <select
          className="form-control w-auto"
          onChange={selectTagEventSelectTagOnChangeHandler}
        >
          {optionsTagInSelectEvent}
        </select>
      </div>
      <div>
        <div className="container-fluid pt-3 px-0">
          <div className="row">
            <div
              className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
              id="container-pie-chart-report-campaign"
            >
              <PieChartReport />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 pt-5 pt-lg-0 ltr">
              <div>{chartComponent}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    whichTypeSelect: state.reportCampaign.which_type_select,
    campaignTypeCategorySelected:
      state.reportCampaign.campaign_type_category_selected,
    campaignIdSelected: state.reportCampaign.campaign_id_selected,
    active_chart: state.reportCampaign.active_chart,
    date_to: state.reportCampaign.date_to,
    date_from: state.reportCampaign.date_from,
    whichSeparationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setEventDataChart: (action) => {
      dispatch({
        type: reportAction.SET_EVENT_DATA_CHART,
        payload: action,
      });
    },
    getCampaignsDataChartWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsDataChartWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChartReport);
